import { colors } from '@globals/themes/defaultTheme'
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import { SxProps } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { T } from '@transifex/react'

const cardStyle: SxProps = {
  p: 2,
  boxShadow: 'none',
  backgroundColor: colors.grayUltraLight,
  borderRadius: 4,
  border: 'none',
}

type AwardPointsRecipientAmountCardProps = {
  pointsAmount: number
  pointsRecipientCount: number
  totalSpend: number | null
  pointsBankAvailableBalance: number
}
const AwardPointsRecipientAmountCard: React.FC<AwardPointsRecipientAmountCardProps> = ({
  pointsAmount,
  pointsRecipientCount,
  totalSpend,
  pointsBankAvailableBalance,
}) => {
  return (
    <Paper component={Stack} sx={cardStyle} direction="row" useFlexGap gap={0.5} mt={2}>
      <SavingsOutlinedIcon color="disabled" />
      <Stack>
        <Typography>
          <T
            _str="{pointsAmount} x {recipientCount} {recipientCount, plural, one {recipient} other {recipients}} = {pointsUsed}"
            pointsAmount={pointsAmount}
            recipientCount={pointsRecipientCount}
            pointsUsed={
              <b>
                <T
                  _str="{totalSpend} {totalSpend, plural, one {point} other {points}} used"
                  totalSpend={totalSpend || 0}
                />
              </b>
            }
          />
        </Typography>
        <Typography>
          <T
            _str="Remaining funds after sending = {remainingFunds}"
            remainingFunds={
              <b>
                <T
                  _str="{remainingPoints} {remainingPoints, plural, one {point} other {points}}"
                  remainingPoints={pointsBankAvailableBalance - (totalSpend || 0)}
                />
              </b>
            }
          />
        </Typography>
        <Typography variant="caption">
          <T _str="Awards are funded by point banks and don't impact your monthly point balance" />
        </Typography>
      </Stack>
    </Paper>
  )
}

export default AwardPointsRecipientAmountCard
